// extracted by mini-css-extract-plugin
export default {"mCard":"_z-z","image":"aA-z","imageNoBackground":"bA-z","imageHasCategory":"cA-z","fullWidth":"dA-z"};